import { Component, OnInit } from '@angular/core';
import { CarrierTypeService } from 'app/services/carrier-type.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { AlertComponent } from 'app/popup/alert.component';
import { ErrorComponent } from 'app/popup/error.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-list-carrier-type',
  templateUrl: './list-carrier-type.component.html',
  styleUrls: ['./list-carrier-type.component.css']
})
export class ListCarrierTypeComponent implements OnInit {

  cTypes: any = [];
  isRemove = false;
  removeRef: any;  
  lblHeading = '';
  message = "Loading Carrier Type...";

  popoverTitle = 'Delete Carrier Type';
  popoverMessage = 'Are you sure you want to delete Carrier Type?';
  confirmText = 'Yes <i class="glyphicon glyphicon-ok"></i>';
  cancelText = 'No <i class="glyphicon glyphicon-remove"></i>';
  confirmClicked = false;
  cancelClicked = false;
  deleteConfirm = '';

  public isLoading = false;
  isEmpty: boolean = false;
  showNum: number = 10;

  constructor(private carrierTypeService: CarrierTypeService,
     private utility: UtilityServiceService,private toastr: ToastrService) { }

  ngOnInit() {
    this.onChangeHeading();
    this.reload();
  }

  reload() {
    this.isLoading = true;
    this.utility.page = 1;
    this.carrierTypeService.getAll().subscribe(result => {
      this.cTypes = result;
      this.utility.onSort(1);
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      this.isEmpty = true;
    });
  }

  onDelete(id: any) {
    this.carrierTypeService.delete(id).subscribe(result => {

      // this.dialogService.addDialog(AlertComponent, { title: 'Delete Carrier Type', message: `Carrier Type ${this.removeRef.code} deleted.`, bold: `${this.removeRef.code}` });
      this.toastr.success(`Carrier Type ${this.removeRef.code} deleted.`,'Delete Carrier Type');

      if (result != null) {
        this.onNo();
        this.reload();
      }
      this.onChangeHeading();
    }, error => {
      error = error.json();
      // this.dialogService.addDialog(ErrorComponent, { title: 'Delete Carrier Type', message: `Carrier Type ${this.removeRef.code} was not deleted.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
      this.toastr.error(`Carrier Type ${this.removeRef.code} was not deleted.`,'Delete Carrier Type');

    });
  }

  onSort() {

  }

  onConfirm(doc: any) {
    this.removeRef = doc;
    this.deleteConfirm = `Are you sure you want to delete Carrier Type <strong>${this.removeRef.code}</strong>?`;
    this.onChangeHeading(false);
    this.isRemove = true;
  }

  onNo() {
    this.isRemove = false;
    this.onChangeHeading();
  }


  onChangeHeading(change: boolean = true) {
    this.lblHeading = (change) ? 'Carrier Types' : 'Delete Carrier Type';
  }




}
